import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Container,
  Spinner,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Alert,
  Row,
  Col,
  Badge,
} from 'reactstrap';
import { createOffer, updateOffer } from '../../redux/actions/offer';
import { getClients } from '../../redux/actions/client';
import { useLocation } from 'react-router-dom';
import { useNavigate  } from 'react-router-dom'
import Loading from '../../components/Loading/Loading';

function CreateOffer() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentLang = useSelector((state) => state.lang.lang);
  const response = useSelector((state) => state.offer.create);
  const responseUpdate = useSelector((state) => state.offer.update);
  const clientState = useSelector((state) => state.client.get);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState('');
  const [id, setId] = useState('');
  const [email, setEmail] = useState('');
  const [wayToPay, setWayToPay] = useState('');
  const [name, setName] = useState('');
  const [rut, setRut] = useState('');
  const [phone, setPhone] = useState('');
  const [obs, setObs] = useState('');
  const [price, setPrice] = useState('');
  const [iva, setIva] = useState('');
  const [comission, setComission] = useState('');
  const [version, setVersion] = useState(1);
  const [alertTitle, setAlertTitle] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const location = useLocation();

  // Estados para la búsqueda de clientes
  const [clientSearch, setClientSearch] = useState('');
  const [clients, setClients] = useState([]);
  const [showClientSuggestions, setShowClientSuggestions] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [useCompanyData, setUseCompanyData] = useState(false);

  const [update, setupdate] = useState(false);

  useEffect(() => {
    if (response && loading && update) {
      if (response.message === 'Offer created') {
        setAlertTitle(response.message);
        setAlertMessage(response.message);
        window.open(response.data);

        setLoading(false);
        setShowAlert(true);
        goToOfferList();
      }
    }
    if (responseUpdate && loading && update) {
      if (responseUpdate.message === 'Offer updated') {
        setAlertTitle(responseUpdate.message);
        window.open(responseUpdate.data);

        setLoading(false);
        setShowAlert(true);
        goToOfferList();
      }
    }
  }, [response, responseUpdate]);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'BGL - Crear Oferta';
  }, []);

  const goToOfferList = () => {
    navigate('/offerlist');
  };

  useEffect(() => {
    if (!location.state?.data) {
      return;
    } else if (update === false) {
      let data = location.state.data;
      setData(data.numerointerno);
      if (data.price) {
        setId(data.id);
        setName(data.name);
        setVersion(data.version);
        setEmail(data.email);
        setPhone(data.phone);
        setObs(data.obs);
        setPrice(data.price);
        setIva(data.iva);
        setComission(data.comission);
        setWayToPay(data.wayToPay);
        setRut(data.rut);
      }
      setLoading(false);
      setupdate(true);
    }
  });

  // Funciones para la búsqueda de clientes
  const handleClientSearch = (e) => {
    const value = e.target.value;
    setClientSearch(value);
    setShowClientSuggestions(true);

    if (value.length > 0) {
      dispatch(getClients(value));
    } else {
      setClients([]);
    }
  };

  const handleClientSelect = (client) => {
    setSelectedClient(client);
    setClientSearch('');
    setUseCompanyData(false); // Reset company data selection

    // Set default data (persona natural)
    setName(client.data.firstName + ' ' + client.data.lastName);
    setRut(client.data.rut || '');
    setEmail(client.data.email || '');
    setPhone(client.data.phone || '');
    setShowClientSuggestions(false);
  };

  const handleRemoveClient = () => {
    setSelectedClient(null);
    setUseCompanyData(false);
    setName('');
    setRut('');
    setEmail('');
    setPhone('');
  };

  const handleCompanyDataToggle = () => {
    if (!selectedClient?.data) return;

    setUseCompanyData(!useCompanyData);

    if (!useCompanyData) {
      // Switch to company data
      const companyInfo = selectedClient.data.companyInfo;
      if (companyInfo) {
        setName(companyInfo.name || '');
        setRut(companyInfo.rut || '');
        // Keep email and phone from personal data
      }
    } else {
      // Switch to personal data
      setName(
        selectedClient.data.firstName + ' ' + selectedClient.data.lastName,
      );
      setRut(selectedClient.data.rut || '');
    }
  };

  const handleCreateClient = () => {
    navigate('/client-form', { state: { returnTo: '/item-offer' } });
  };

  // Effect para manejar los datos de clientes
  useEffect(() => {
    if (clientState?.data) {
      setClients(clientState.data);
    }
  }, [clientState]);

  const onDismiss = () => setShowAlert(false);

  const onFormSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    if (id) {
      dispatch(
        updateOffer(
          id,
          data,
          name,
          rut,
          email,
          phone,
          obs,
          price,
          iva,
          comission,
          wayToPay,
          version,
        ),
      );
    } else {
      dispatch(
        createOffer(
          data,
          name,
          rut,
          email,
          phone,
          obs,
          price,
          iva,
          comission,
          wayToPay,
          version,
        ),
      );
    }
  };

  function numberWithDot(x) {
    let n = x.split('.').join('');
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  const onChangeValue = (value) => {
    let n = numberWithDot(value);
    setPrice(n);
  };

  return loading ? (
    <Loading />
  ) : (
    <>
      <Container>
        <Alert isOpen={showAlert} toggle={onDismiss}>
          {alertTitle} - {alertMessage}
        </Alert>
      </Container>
      <Container
        className={'p-3 container-border'}
        style={{ marginTop: '10px' }}
      >
        <h2 style={{ textAlign: 'center' }}>NUMERO INTERNO: {data}</h2>
        <Form onSubmit={(e) => onFormSubmit(e)}>
          <Row>
            <Col lg="4"></Col>
            <Col sm="12" lg="12">
              <FormGroup>
                <Label for="clientSearch">Cliente</Label>
                <section className="position-relative">
                  {selectedClient?.data ? (
                    <section>
                      <section className="d-flex align-items-center mb-2">
                        <Badge color="primary" className="mr-2 p-2">
                          {useCompanyData && selectedClient.data.isCompany
                            ? selectedClient.data.companyInfo?.name
                            : selectedClient.data.firstName +
                              ' ' +
                              selectedClient.data.lastName}{' '}
                          -{' '}
                          {useCompanyData && selectedClient.data.isCompany
                            ? selectedClient.data.companyInfo?.rut
                            : selectedClient.data.rut}
                        </Badge>
                        <Button
                          color="link"
                          size="sm"
                          className="p-0"
                          onClick={handleRemoveClient}
                        >
                          <i className="fa fa-times"></i>
                        </Button>
                      </section>
                      {selectedClient.data.isCompany && (
                        <section className="mb-2">
                          <Label check className="d-flex align-items-center">
                            <Input
                              type="checkbox"
                              checked={useCompanyData}
                              onChange={handleCompanyDataToggle}
                              className="mr-2"
                            />
                            Desea oferta por empresa
                          </Label>
                        </section>
                      )}
                    </section>
                  ) : (
                    <Input
                      id="clientSearch"
                      type="text"
                      placeholder="Buscar cliente por nombre, apellido, RUT, teléfono o correo electrónico"
                      value={clientSearch}
                      onChange={handleClientSearch}
                      onBlur={() =>
                        setTimeout(() => setShowClientSuggestions(false), 200)
                      }
                      disabled={loading}
                    />
                  )}
                  {showClientSuggestions && (
                    <section
                      className="position-absolute w-100 bg-white border rounded-bottom"
                      style={{ zIndex: 1000 }}
                    >
                      {clients.length > 0 ? (
                        clients.map((client) => (
                          <section
                            key={client.id}
                            className="px-3 py-2 cursor-pointer hover-bg-light"
                            onClick={() => handleClientSelect(client)}
                          >
                            <span className="font-weight-bold">
                              {client.data.firstName} {client.data.lastName}
                            </span>
                            {client.data.isCompany && (
                              <span className="text-info ml-2">
                                <i className="fa fa-building mr-1"></i>
                                Empresa: {client.data.companyInfo?.name}
                              </span>
                            )}
                            <br />
                            <span className="text-muted">
                              {client.data.rut} | {client.data.phone}
                            </span>
                          </section>
                        ))
                      ) : (
                        <section className="px-3 py-2">
                          <p className="mb-0">No se encontraron clientes</p>
                          <Button
                            color="primary"
                            size="sm"
                            className="mt-2"
                            onClick={handleCreateClient}
                          >
                            <i className="fa fa-plus mr-2"></i>
                            Crear nuevo cliente
                          </Button>
                        </section>
                      )}
                    </section>
                  )}
                </section>
              </FormGroup>
              <FormGroup>
                <Label for="name">Nombre</Label>
                <Input
                  type="text"
                  placeholder="Nombre..."
                  disabled={loading}
                  onChange={(e) => setName(e.target?.value)}
                  value={name}
                />
              </FormGroup>
              <FormGroup>
                <Label for="rut">RUT</Label>
                <Input
                  type="text"
                  placeholder="RUT..."
                  disabled={loading}
                  onChange={(e) => setRut(e.target?.value)}
                  value={rut}
                />
              </FormGroup>
              <FormGroup>
                <Label for="email">Email</Label>
                <Input
                  type="text"
                  placeholder="Email..."
                  disabled={loading}
                  onChange={(e) => setEmail(e.target?.value)}
                  value={email}
                />
              </FormGroup>
              <FormGroup>
                <Label for="phone">Telefono</Label>
                <Input
                  type="text"
                  placeholder="Telefono..."
                  disabled={loading}
                  onChange={(e) => setPhone(e.target?.value)}
                  value={phone}
                />
              </FormGroup>
              <FormGroup>
                <Label for="price">Valor</Label>
                <Input
                  type="text"
                  placeholder="Valor..."
                  disabled={loading}
                  onChange={(e) => {
                    const inputValue = e.target?.value;
                    const numericValue = inputValue.replace(/[^0-9.]/g, '');
                    onChangeValue(numericValue);
                  }}
                  value={price}
                />
              </FormGroup>
              <FormGroup>
                <Label for="iva">IVA</Label>
                <Input
                  type="select"
                  disabled={loading}
                  onChange={(e) => setIva(e.target?.value)}
                  value={iva}
                >
                  <option value="" style={{ display: 'none' }}>
                    Eliga una opcion
                  </option>
                  <option value="+ IVA">+ IVA</option>
                  <option value="Con IVA">Con IVA</option>
                  <option value="Exento de IVA">Exento de IVA</option>
                </Input>
              </FormGroup>
              <FormGroup>
                <Label for="comission">Comisión</Label>
                <Input
                  type="text"
                  placeholder="Comisión..."
                  disabled={loading}
                  onChange={(e) => {
                    const inputValue = e.target?.value;
                    const numericValue = inputValue.replace(/[^0-9.]/g, '');
                    setComission(numericValue);
                  }}
                  value={comission}
                />
              </FormGroup>
              <FormGroup>
                <Label for="contact">Forma de Pago</Label>
                <Input
                  type="select"
                  disabled={loading}
                  onChange={(e) => setWayToPay(e.target?.value)}
                  value={wayToPay}
                >
                  <option value="" style={{ display: 'none' }}>
                    Eliga una opción
                  </option>
                  <option value="Crédito">Crédito</option>
                  <option value="Contado">Contado</option>
                </Input>
              </FormGroup>
            </Col>
            <Col lg="4"></Col>
          </Row>
          <FormGroup>
            <Label for="name">Observaciones</Label>
            <Input
              type="textarea"
              placeholder="Observaciones..."
              disabled={loading}
              onChange={(e) => setObs(e.target?.value)}
              value={obs}
            />
          </FormGroup>
          <Button disabled={loading}>Guardar</Button>
        </Form>
      </Container>
    </>
  );
}
export default CreateOffer;
